import { useCallback, useEffect } from 'react';

const setTitle = (title: string, asPostFix: boolean) => {
  const prefix = asPostFix ? 'Bestill | RiksTV - ' : '';
  document.title = prefix + title;
};

export const useTitle = (title: string, asPostFix = false) => {
  useEffect(() => {
    setTitle(title, asPostFix);
  }, [title, asPostFix]);
};

export const useTitleCallback = () => {
  return useCallback((title: string, asPostFix = false) => {
    setTitle(title, asPostFix);
  }, []);
};
